/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Error_Multiple_TriggersInputs */

const cs_workflow_error_multiple_triggers = /** @type {(inputs: Workflow_Error_Multiple_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow může mít pouze jeden spouštěcí uzel.`)
};

const en_workflow_error_multiple_triggers = /** @type {(inputs: Workflow_Error_Multiple_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow can have only one trigger node.`)
};

/**
* | output |
* | --- |
* | "Workflow can have only one trigger node." |
*
* @param {Workflow_Error_Multiple_TriggersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_error_multiple_triggers = /** @type {((inputs?: Workflow_Error_Multiple_TriggersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Error_Multiple_TriggersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_error_multiple_triggers(inputs)
	return cs_workflow_error_multiple_triggers(inputs)
});